import { TableContainerWrap } from '@components/Table/TableComponent.style';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const TableContainer = styled(TableContainerWrap)`
  padding-bottom: 5rem;
`;
